import {
  GridActionsCellItem,
  GridColumns,
  GridRenderCellParams,
  GridRowParams
} from '@mui/x-data-grid-premium';
import SectionTitle from 'components/common/SectionTitle';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import {
  dateFilterOperators,
  filterOperators,
  TransportDocumentActiveStatus
} from '../../../../constants';
import { baseCell } from '../cells/base-cell';

import { dateCell } from '../cells/date-cell';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ReplayIcon from '@mui/icons-material/Replay';
import { IStatusOption } from 'interfaces';
import { isDirector } from 'components/helpers/IsDirector';

export function TransportActiveDocumentColumns(
  isLinkable: boolean,
  downloadAttachment: any,
  regenerateDocument: any,
  isSupplierDdt?: boolean
): GridColumns {
  const { t } = useTranslation();
  const isDir = isDirector();

  const statusOptions: IStatusOption[] = Object.entries(TransportDocumentActiveStatus).map(
    ([display_name, key]) => {
      return {
        value: Number(key),
        display_name: String(display_name)
      };
    }
  );

  const columns: GridColumns = [
    {
      field: 'ref',
      headerName: t(isSupplierDdt ? `entities.supplier-active-ddt.ref` : `entities.ddt.ref`),
      width: 175,
      renderCell: (params: GridRenderCellParams<string>) =>
        isLinkable ? (
          <NavLink to={`./${params.row?.id}`}>
            <SectionTitle>{params.value}</SectionTitle>
          </NavLink>
        ) : (
          <SectionTitle>{params.value}</SectionTitle>
        )
    },
    {
      field: 'date',
      headerName: t(isSupplierDdt ? `entities.supplier-active-ddt.date` : `entities.ddt.date`),
      filterOperators: dateFilterOperators,
      width: 125,
      renderCell: dateCell
    },
    {
      field: 'order_ref',
      headerName: t(`global.order`),
      filterOperators,
      width: 125,
      renderCell: baseCell
    },
    {
      field: 'status',
      headerName: t(`global.status`),
      width: 100,
      type: 'singleSelect',
      valueOptions: statusOptions.map((opt) => {
        return {
          value: String(opt.value),
          label: opt.display_name
        };
      }),
      renderCell: ({ value }) => (
        <span className={value === 'ACTIVE' ? 'text-green-500' : 'text-orange-500'}>
          {t(`entities.active-ddt.status.${value}`)}
        </span>
      )
    },
    {
      field: 'warehouse_out',
      headerName: t(`global.warehouse_out`),
      filterOperators,
      width: 200,
      renderCell: baseCell
    }
  ];

  if (isSupplierDdt) {
    columns.push({
      field: 'supplier',
      headerName: t(`global.supplier`),
      filterOperators,
      width: 200,
      renderCell: baseCell
    });
  } else {
    columns.push({
      field: 'warehouse_in',
      headerName: t(`global.warehouse_in`),
      filterOperators,
      width: 200,
      renderCell: baseCell
    });
  }

  columns.push({
    field: 'actions',
    type: 'actions',
    headerName: t(`global.actions`),
    getActions: (params: GridRowParams) => {
      const actions = [];
      actions.push(
        <GridActionsCellItem
          key={998}
          icon={<CloudDownloadIcon />}
          onClick={() => downloadAttachment(params.row?.id)}
          label="Download"
        />
      );
      if (!isDir) {
        actions.push(
          <GridActionsCellItem
            icon={<ReplayIcon />}
            onClick={() => regenerateDocument(params.row?.id)}
            label="Regenerate"
          />
        );
      }

      return actions;
    }
  });

  return columns;
}
